import { styled, theme, utils } from 'ui/theme';
import { Overlay } from 'ui/components/primitives';

export const Drawer = {
  Container: styled.div`
    background-color: ${theme.colors.build.lightDark1};
    backface-visibility: hidden;
    bottom: 0px;
    right: 0px;
    position: fixed;
    top: 0px;
    transform: translateX(100%);
    transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
    width: 100%;
    z-index: 800;

    &[data-open='true'] {
      box-shadow: ${theme.shadows.down.mid};
      transform: translateX(0px);
    }

    ${utils.media.min('l')`
      width: 464px;
    `}

    ${utils.media.min('xl')`
      width: 464px;
    `};
  `,

  Overlay: styled(Overlay)`
    &[data-visible='true'] {
      z-index: 799;
    }
  `,

  Component: styled.header`
    align-items: center;
    background-color: ${theme.colors.build.lightDark2};
    display: flex;
    height: ${theme.sizes[14]};
    justify-content: flex-start;
  `,
};
